import React from 'react';
import '../styles/HomePage.css';

const Hero: React.FC = () => {
  return (
    <section className='hero'>
      <h1>
        A collaborative research tool to enable innovators in the national
        security ecosystem
      </h1>
      <div className='video-container'>
        <iframe
          src='https://www.youtube.com/embed/lVE-fP79qJo'
          title='Athena 4 Partners: A Collaborative Research Tool in Support of the National Security Ecosystem'
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
          referrerPolicy='strict-origin-when-cross-origin'
          allowFullScreen
        ></iframe>
      </div>
    </section>
  );
};

export default Hero;
